module.exports = __webpack_public_path__ + "img/10.a407d3c6.jpg";